module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/headers-styles/header-style1/header-style1.component.scss
// module id = ./src/app/features/headers-styles/header-style1/header-style1.component.scss
// module chunks = main